import React from 'react';
import { Link } from 'react-router-dom';
import './OScontent.css';


const OScontent = () => {
    return (
        <div className="OS-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Operating Systems</h1>
                <nav className="os-breadcrumb" style={{ margin: '4px 0 12px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                    <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                    <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                    <span>Operating Systems</span>
                </nav>
            </div>
            <h1 className="OS-Section-title">Largest Range of Operating Systems</h1>


            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/slant-2.webp" />
                </div>
                <div className="OS-text">
                    <h4>Motorized Blinds</h4>
                    <p>Motorized Blinds make your work efficient and effortless. It is specially useful for those hard to reach places. We offer blend of design, technology & innovation so, you can choose from wide range of controllers to satisfy all your automation needs and comfort to make life easier</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/home-automation.webp" />
                </div>
                <div className="OS-text">
                    <h4>Home Automation</h4>
                    <p>Callistus most of blinds are available with Motorization, which provides effortless, cordless operation. You can operate with remote and computable with home automation and smart home automation systems, you can program your blinds to reposition on a schedule that you set. Move your blinds on command.</p>
                </div>
            </div>


            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/tdbu.webp" />
                </div>
                <div className="OS-text">
                    <h4>Top Down Bottom Up (TDBU)</h4>
                    <p>Top-Down/Bottom-Up offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light. Also you can hold the blind in middle to let sunlight from top as well as bottom.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/day-and-night.webp" />
                </div>
                <div className="OS-text">
                    <h4>Day and Night</h4>
                    <p>Day & Night operating system offers maximum light control by using two separate fabric panels to achieve a day/night level of convenience, providing limitless options for privacy and light control.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/cluch-system.webp" />
                </div>
                <div className="OS-text">
                    <h4>Clutch Operating</h4>
                    <p>Callistus Clutch System for Colby blinds uses a retractable cord to raise and lower your blind while maintaining a constant cord length. There are no long, dangling cords to detract from the appearance of your window covering which is Ideal for child and pet safety.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/wand-cantrol.webp" />
                </div>
                <div className="OS-text">
                    <h4>Wand Control</h4>
                    <p>Callistus offers Wand control for Sierra, Eton and Vertical Blinds, so making them completely Child Safe by Design. You can control the blind and draw it to either the left or right as per your need.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/one-touch-up.webp" />
                </div>
                <div className="OS-text">
                    <h4>One-Touch Up</h4>
                    <p>One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own. One touch Up system enhances both beauty and safety.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/one-touch-down.webp" />
                </div>
                <div className="OS-text">
                    <h4>One-Touch Down</h4>
                    <p>One Touch Down is a smart system wherein you just need to pull the operating chain, and the blind will start unfolding on its own. One touch down system enhances both beauty and safety.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/roller-manual.webp" />
                </div>
                <div className="OS-text">
                    <h4>Manual with Ball Chain</h4>
                    <p>A hook fitted to an adjacent wall which chains and cords are hooked through to keep taut and out of reach of children.</p>
                </div>
            </div>

            <div className="OS-section">
                <div className="OS-image">
                    <img src="/Assets/OSimages/manual-with-cord.webp" />
                </div>
                <div className="OS-text">
                    <h4>Manual with Cord</h4>
                    <p>Cord system is the traditional operating system of functioning the window blinds. It provides smooth operation for opening and closing of blinds and also for tilting the same.</p>
                </div>
            </div>

        </div>
    );
};

export default OScontent;